export const STATUS_LABELS = {
  noua: "Nouă",
  confirmata: "Confirmată",
  expediata: "Expediată",
  livrata: "Livrată",
  anulata: "Anulată",
};

export const STATUS_COLORS = {
  noua: "bg-sky-100 text-sky-800 hover:bg-sky-100",
  confirmata: "bg-amber-100 text-amber-800 hover:bg-amber-100",
  expediata: "bg-indigo-100 text-indigo-800 hover:bg-indigo-100",
  livrata: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100",
  anulata: "bg-rose-100 text-rose-800 hover:bg-rose-100",
};

export const STATUS_OPTIONS = ["noua", "confirmata", "expediata", "livrata", "anulata"];
